var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_880_405)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.5,
    cy: 65.5,
    rx: 61.5,
    ry: 62.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 4C97.1 4 124 30.9 124 64C124 97.1 97.1 124 64 124C30.9 124 4 97.1 4 64C4 30.9 30.9 4 64 4ZM64 0C28.7 0 0 28.7 0 64C0 99.3 28.7 128 64 128C99.3 128 128 99.3 128 64C128 28.7 99.3 0 64 0ZM47 64L33.4 77.6C28.7 82.3 28.7 89.9 33.4 94.6C38.1 99.3 45.7 99.3 50.4 94.6L64 81L77.6 94.6C82.3 99.3 89.9 99.3 94.6 94.6C99.3 89.9 99.3 82.3 94.6 77.6L81 64L94.6 50.4C99.3 45.7 99.3 38.1 94.6 33.4C89.9 28.7 82.3 28.7 77.6 33.4L64 47L50.4 33.4C45.7 28.7 38.1 28.7 33.4 33.4C28.7 38.1 28.7 45.7 33.4 50.4L47 64ZM36.2 80.4C33.1 83.5 33.1 88.6 36.2 91.7C39.3 94.8 44.4 94.8 47.5 91.7L64 75.3L80.4 91.7C83.5 94.8 88.6 94.8 91.7 91.7C94.8 88.6 94.8 83.5 91.7 80.4L75.3 64L91.7 47.6C94.8 44.5 94.8 39.4 91.7 36.3C88.6 33.2 83.5 33.2 80.4 36.3L64 52.7L47.6 36.2C44.5 33.1 39.4 33.1 36.3 36.2C33.2 39.3 33.2 44.4 36.3 47.5L52.7 64L36.2 80.4Z",
    fill: "#FFA502"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2 80.4001L52.7 64.0001L36.2 47.6001C33.1 44.5001 33.1 39.4001 36.2 36.3001C39.3 33.2001 44.4 33.2001 47.5 36.3001L64 52.7001L80.4 36.3001C83.5 33.2001 88.6 33.2001 91.7 36.3001C94.8 39.4001 94.8 44.5001 91.7 47.6001L75.3 64.0001L91.7 80.4001C94.8 83.5001 94.8 88.6001 91.7 91.7001C88.6 94.8001 83.5 94.8001 80.4 91.7001L64 75.3001L47.6 91.8001C44.5 94.9001 39.4 94.9001 36.3 91.8001C33.1 88.6001 33.1 83.6001 36.2 80.4001Z",
    fill: "#3A98FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_880_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalError);
export default __webpack_public_path__ + "static/media/ModalError.61df62d4dbf42d528d1e45eeb9b86756.svg";
export { ForwardRef as ReactComponent };